/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext, useEffect, useState } from "react";
import Modal from "../../Components/Modal";
import {
  AnswerState,
  QuestionnaireState,
  QuestionsContext,
} from "../../Context/questionsContext";
import { Vocabulary } from "../../Utils/Vocabulary";
import AddAndShowImages from "../Devices/AddAndShowImages";
import { getData } from "../../Services/getData";
import { UrlEnum } from "../../Utils/Utils";
import { Button, Divider } from "@mui/material";
import theme from "../../Theme/Theme";

type AddImagesProps = {
  openModal: boolean;
  handleCloseModal: () => void;
  state: QuestionnaireState | AnswerState;
  saveQuestionnaires: (e: any) => void;
};

export default function AddImages(props: AddImagesProps) {
  const { state, openModal, handleCloseModal, saveQuestionnaires } = props;
  const [showDropzone, setShowDropzone] = useState(true);
  const [dropzoneFiles, setDropzoneFiles] = useState<Array<any>>([]);
  const [localState, setLocalState] = useState<
    QuestionnaireState | AnswerState
  >(structuredClone(state));
  const [images, setImages] = useState<Array<string>>([]);
  const questionsContext = useContext(QuestionsContext);

  useEffect(() => {
    if (localState.images && localState.images.length !== 0)
      setShowDropzone(false);
    getAllImages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal]);

  function getAllImages() {
    getData(`${UrlEnum.questionnaire}/images`).then((response) => {
      if (response && response.data) {
        setImages(response.data);
      }
    });
  }
  /**
   *
   */
  function handleDeleteImages(newImageList: any, newFileList: any) {
    const newLocalState = structuredClone(localState);
    newLocalState.images = newImageList;
    newLocalState.files = newFileList;
    setLocalState(newLocalState);
    // const newQuestions = questionsContext.questions.slice();
    // questionsContext.setQuestions(newQuestions);
  }

  /**
   *
   * @param files
   */
  function handleChangeFiles(files: any) {
    const newLocalState = structuredClone(localState);
    newLocalState.files = files;
    setLocalState(newLocalState);
    // const newQuestions = questionsContext.questions.slice();
    // questionsContext.setQuestions(newQuestions);
  }

  /**
   *
   */
  function showImages() {
    const newLocalState = structuredClone(localState);

    if (newLocalState.images) {
      newLocalState.images = [...newLocalState.images, ...dropzoneFiles] as any;
    } else {
      newLocalState.images = [...dropzoneFiles] as any;
    }
    setLocalState(newLocalState);
    setShowDropzone(false);
    // const newQuestions = questionsContext.questions.slice();
    // questionsContext.setQuestions(newQuestions);
  }

  return (
    <div>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        title={Vocabulary.addImages}
        maxWidth={950}
      >
        {showDropzone ? (
          <>
            <div>
              {images.map((image, index) => (
                <img
                  src={image}
                  alt=""
                  style={{
                    height: 100,
                    marginRight: 10,
                    padding:
                      localState.images && localState.images[0] === image
                        ? 5
                        : 0,
                    border:
                      localState.images && localState.images[0] === image
                        ? "1px solid #519E00"
                        : "none",
                    borderRadius: 10,
                  }}
                  onClick={() => {
                    localState.images = [image] as any;
                    const newQuestions = questionsContext.questions.slice();
                    questionsContext.setQuestions(newQuestions);
                  }}
                />
              ))}
            </div>
            <Divider />
          </>
        ) : null}
        <div>
          <AddAndShowImages
            state={localState}
            gridSize={12}
            showDropzone={showDropzone}
            filesLimit={1}
            setDropzoneFiles={setDropzoneFiles}
            setShowDropzone={setShowDropzone}
            handleDeleteImages={handleDeleteImages}
            handleChangeFiles={handleChangeFiles}
            showImages={showImages}
          />
        </div>
        {showDropzone ? null : (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: 13,
            }}
          >
            <Button
              onClick={handleCloseModal}
              style={{ backgroundColor: theme.palette.errorColor?.main }}
              variant="contained"
            >
              {Vocabulary.cancel}
            </Button>
            <Button
              variant="contained"
              onClick={(e: any) => {
                state.images = localState.images;
                state.files = localState.files;
                const newQuestions = questionsContext.questions.slice();
                questionsContext.setQuestions(newQuestions);
                handleCloseModal();
                saveQuestionnaires(e);
              }}
            >
              {Vocabulary.save}
            </Button>
          </div>
        )}
      </Modal>
    </div>
  );
}
